import CoreBase from '../../../../../services/engines/CoreBase';
import iframeController from '../IframeController';
import entryUpdater from '../EntryUpdater';

const _maxTextLength = 160;

class AppendHandler extends CoreBase {
    _name = 'AppendHandler';

    /**
     * Handles jerny:append — adds a new entry to body.userInput and persists.
     * @param {MessageEvent} e
     * @param {HTMLIFrameElement} iframe
     * @param {object} entry
     */
    handle = (e, iframe, entry) => {
        try {
            if (e.source !== iframe?.contentWindow) return;

            const item = e.data?.entry;
            if (!item?.ems) return;

            // Validate plain item
            if (!item.type || item.type === 'item') {
                const text = item.text;
                if (!text || typeof text !== 'string') return;
                if (text.length > _maxTextLength) return;
            }

            // Validate meal or action item
            if (item.type === 'meal' || item.type === 'action') {
                if (!Array.isArray(item.items) || item.items.length === 0) return;
            }

            const body = iframeController.parseBody(entry);
            if (!body) return;

            if (!Array.isArray(body.userInput)) body.userInput = [];
            body.userInput.push(item);

            entryUpdater.update(entry, body);
        } catch (error) {
            this.logError('handle', error.message);
        }
    };
}

const appendHandler = new AppendHandler();
export default appendHandler;
